import React from 'react';
import { industries } from '../data/mockData';

const IndustriesSection = () => {
  return (
    <section data-testid="industries-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="max-w-2xl mb-16">
          <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#002FA7] mb-4">Industries We Serve</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.2] text-[#0A0F1C] mb-5">
            Brand Protection Across Every Sector
          </h2>
          <p className="text-base text-[#4B5563] leading-relaxed">
            From tech startups to retail empires, businesses across every industry trust us to protect their intellectual property.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-px bg-[#E5E7EB]">
          {industries.map((industry, i) => (
            <div
              key={i}
              data-testid={`industry-${i}`}
              className="bg-white p-6 flex items-center justify-center text-center group cursor-default transition-all duration-500 hover:bg-[#0A0F1C]"
            >
              <span className="text-sm font-medium text-[#0A0F1C] group-hover:text-white transition-colors duration-500">
                {industry}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
